import { defineStore } from "pinia";
import { computed, reactive } from "vue";
import api from "../../service";
import { getUserPicturePath } from "../utils/imageUtils";
import { authenticateUser, refreshToken } from "./utils/authUtils";

const customSerializer = {
	serialize: (state) => JSON.stringify(state.state), // Serialize only the state object
	deserialize: (value) => ({ state: JSON.parse(value) }), // Deserialize and wrap it back in an object
};

export const useAuthStore = defineStore(
	"auth",
	() => {
		const state = reactive({
			user: {
				userType: null,
			},
			config: {
				base_url: null,
				companyName: null,
				companyUrlName: null,
			},
			isAuthenticated: false,
			token: null,
		});

		const isAuthenticated = computed(() => {
			return state && state.isAuthenticated;
		});

		const userType = computed(() => {
			return state && state.user.userType;
		});

		const user = computed(() => {
			return state && state.user;
		});

		const config = computed(() => {
			return state && state.config;
		});

		const login = async ({ email, password, companyUrlName }) => {
			const res = await authenticateUser("student", {
				email,
				password,
				companyUrlName,
			});
			const data = res?.data;
			const errors = res?.errors;
			state.config.base_url = api.defaults.baseURL;
			state.isAuthenticated = !!data?.token;
			state.token = data?.token;
			state.user = data?.user;
			state.user.userType = data?.user?.user_id ? "user" : "student";
			state.user.profilePicturePath = await getUserPicturePath(
				state.user.profilePicture,
				state.user.folderName,
				"students",
			);
			return { status: res.status, errors: errors };
		};

		const refresh = async () => {
			const { data, errors } = await refreshToken("student");
			state.isAuthenticated = !!data?.token;
			state.token = data?.token;
			return { data, errors };
		};

		const logout = () => {
			state.user = { userType: null };
			state.isAuthenticated = false;
			state.token = null;
		};

		const setUserType = (type) => {
			state.user = { userType: type };
		};

		const setProfilePicture = (path) => {
			state.user.profilePicturePath = path;
		};

		return {
			state,
			isAuthenticated,
			user,
			userType,
			config,
			setUserType,
			setProfilePicture,
			login,
			refresh,
			logout,
		};
	},
	{
		persist: {
			key: "authState",
			paths: ["state"],
			serializer: customSerializer,
		},
	},
);
